import React, { Component } from "react";

//Styles
import styles from "./verificationMessage.module.css";

class VerificationMessage extends Component {
  render() {
    const changeRoute = () => {
      this.props.history.push("/login");
    };

    return (
      <div
        className={styles.container}
        style={{ backgroundImage: "url(../signupBack.svg)" }}
      >
        <div className={styles.card}>
          <div className={styles.textMessage}>
            We will notify you once your account is verified
          </div>
          <div className={styles.submitButtonContainer}>
            <button
              onClick={changeRoute}
              type="button"
              className={styles.submitButton}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    );
  }
}
export default VerificationMessage;
